module.exports = __webpack_public_path__ + "img/appBarMovile.00637583.png";